export default __webpack_public_path__ + "static/media/af.4746d62d.svg";